import React, { useRef, useCallback } from "react";
import LightGallery from "lightgallery/react";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
import { GalleryContainer } from "../styles";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  WorkGallerySection,
  WorkHighlightBand,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function HoloConnect() {
  const ProjectBG = require("../../../../assets/videos/holo-connect/poster.png");
  const Grid1 = require("../../../../assets/videos/holo-connect/HoloConnect_1.png");
  const Grid2 = require("../../../../assets/videos/holo-connect/HoloConnect_2.png");
  const Grid3 = require("../../../../assets/videos/holo-connect/HoloConnect_3.png");

  const lightGallery = useRef<any>(null);
  const items = [
    { id: "1", size: "1400-933", src: Grid1, thumb: Grid1, subHtml: `` },
    { id: "2", size: "1400-933", src: Grid2, thumb: Grid2, subHtml: `` },
    { id: "3", size: "1400-932", src: Grid3, thumb: Grid3, subHtml: `` },
  ];

  const onInit = useCallback((detail: any) => {
    if (detail) lightGallery.current = detail.instance;
  }, []);

  const getItems = useCallback(() => {
    return items.map((item) => (
      <a
        key={item.id}
        data-lg-size={item.size}
        className="gallery-item"
        data-src={item.src}
        href={item.src}
      >
        <img
          className="img-responsive w-100 rounded"
          src={item.thumb}
          alt="HoloConnect gallery preview"
        />
      </a>
    ));
  }, [items]);

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="HoloConnect"
      lead={
        <p>
          Remote multi-user collaboration on HoloLens: shared mixed-reality
          spaces, avatars, and spatial content so teams work together beyond
          physical distance.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={Grid1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/argo-hytos/1_HoloConnect.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Remote multi-user collaboration</WorkSectionHeading>
          <p>
            HoloLens users join a shared space in realtime—interact with content
            and each other&apos;s avatars for distributed teamwork.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <video controls poster={Grid2}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/argo-hytos/2_HoloConnect.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Immersive shared experiences</WorkSectionHeading>
          <p>
            Place virtual objects in the real world for reviews, annotations,
            3D models, and spatially aware meetings.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow>
        <WorkMediaFrame>
          <img src={Grid3} alt="" />
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Realtime communication</WorkSectionHeading>
          <p>
            Voice, ideation, and joint problem-solving as if you were
            co-located—faster decisions and stronger alignment.
          </p>
          <WorkSectionHeading>Versatile applications</WorkSectionHeading>
          <p>
            Training, design reviews, virtual conferences, and remote
            assistance share the same collaborative foundation.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkHighlightBand>
        <p>
          HoloConnect merges physical and digital presence for highly immersive
          multi-user workflows—built for teams that need spatial collaboration at
          distance.
        </p>
      </WorkHighlightBand>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "HoloConnect" },
          { label: "Period", value: "2020 - 2021" },
          { label: "Client", value: "Radiusmedia KG" },
          {
            label: "Engine & Tools",
            value: "Unity, Mixed Reality Toolkit, C#",
          },
          { label: "Platform", value: "HoloLens 2" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "MR, HoloLens, Multi-user" },
        ]}
      />

      <WorkGallerySection>
        <GalleryContainer>
          <LightGallery
            plugins={[lgVideo, lgZoom]}
            elementClassNames="gallery-custom-wrapper row flex-column flex-sm-row"
            onInit={onInit}
            data-lg-size={2}
          >
            {getItems()}
          </LightGallery>
        </GalleryContainer>
      </WorkGallerySection>
    </WorkProjectShell>
  );
}
